var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"d-none d-md-inline-flex",attrs:{"color":"primary","text":""}},'v-btn',attrs,false),on),[_vm._v(" "+_vm._s(_vm.label)+" ")])]}}])},[_c('v-list',_vm._l((_vm.items),function(item,index){return _c('v-list-item',{key:index,attrs:{"to":item.url}},[_c('v-list-item-title',[_vm._v(_vm._s(item.label))])],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }